export const isFarsiInput = (text) => {
    return /^[\u0600-\u06FF\uFB8A-\uFEEF\uFB50-\uFDFF\u200C\s]*$/.test(text);
};

export const isEnglishInput = (text) => {
    return /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]*$/.test(text);
};

export const validateEmail = (email) => {
    const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return emailRegex.test(email);
};

export const validate = (formData, instanceConfig) => {
    let errors = {};
    
    // Get required fields from instanceConfig.requiredFields (legacy) or from fields with required: true
    let requiredFields = instanceConfig?.requiredFields || [];
    
    // If no requiredFields array, check fields with required: true
    if (requiredFields.length === 0 && instanceConfig?.fields) {
        requiredFields = Object.keys(instanceConfig.fields).filter(field => {
            const fieldConfig = instanceConfig.fields[field];
            // Check if field is required (can be boolean or function)
            const isRequired = typeof fieldConfig.required === 'function' 
                ? fieldConfig.required(formData)
                : fieldConfig.required === true;
            
            // Also check condition - field must be visible to be required
            const isVisible = !fieldConfig.condition || fieldConfig.condition(formData);
            
            return isRequired && isVisible;
        });
    }
    
    requiredFields.forEach(field => {
        const fieldConfig = instanceConfig?.fields?.[field];
        
        // Double-check condition at validation time
        if (fieldConfig?.condition && !fieldConfig.condition(formData)) {
            return; // Skip validation if field is not visible
        }
        
        if (typeof formData[field] === 'string') {
            if (!formData[field].trim()) {
                errors[field] = 'این فیلد ضروری است';
            }
        } else if (formData[field] == null || formData[field] === '') {
            errors[field] = 'این فیلد ضروری است';
        }
    });

    if (formData.email && !validateEmail(formData.email)) {
        errors.email = 'Invalid email format';
    }
    return errors;
};
